import React from 'react'
import foto from '../../Imagenes/Logo.png'
import foto1 from "../../Imagenes/logo imperfect.jpg";
const Logo = () => {
  return (
    <div><img src={foto1} alt ="logo" width="50px" height="50px"     style={{ borderRadius: "50%" }}
/></div>
  )
}

export default Logo